import { Response, PermissionEnum, apiAbortController } from '@ui/src';
import { Account } from '../../hoc/accounts/types';
import api from '../../api/api';
import { Employee } from './types';

export interface PermissionReponse {
  permissions: PermissionEnum[];
}

interface PspPartner {
  id: string;
  companyName: string;
  description?: string;
}

export const accountsDictionariesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccountsSettings: build.query<
      Response<{ key: string; data: { value: boolean } }>,
      void
    >({
      query: () => ({
        url: '/v1/settings?take=9999',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsTransactionTypes: build.query<
      Response<{ name: string; id: string }>,
      void
    >({
      query: () => ({
        url: '/v1/transactions-types?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccounts: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPspAccounts: build.query<Response<any>, void>({
      query: () => ({
        url: '/v1/psp-accounts?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsTransactionsPspPartners: build.query<
      Response<PspPartner>,
      string
    >({
      query: (query) => ({
        url: `/v1/psp-partners${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsEmployee: build.query<{ data: Employee }, void>({
      query: () => ({
        url: `/v1/employees/whoami`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetAccountsTransactionsPspPartnersQuery,
  useLazyGetAccountsQuery,
  useLazyGetPspAccountsQuery,
  useLazyGetAccountsEmployeeQuery,
  useLazyGetAccountsTransactionTypesQuery,
  useLazyGetAccountsSettingsQuery,
} = accountsDictionariesApi;

export const {
  endpoints: {
    getAccounts,
    getPspAccounts,
    getAccountsEmployee,
    getAccountsTransactionTypes,
    getAccountsSettings,
  },
} = accountsDictionariesApi;
